import React from "react";

export default function AccessDeniedPage() {
  return <h1>Access Denied</h1>;
}
